import styled from 'styled-components';
import { WebAsset } from '@styled-icons/material/WebAsset';

const NonMonitoredAssetListBlock = styled.div`
  border-radius: 8px;

  .tab-name-block {
    padding: 8px 16px;
    cursor: pointer;
  }

  .tab-name-block: hover {
    background-color: var(--sops-dropdown-hover-bg);
  }

  .tab-name {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
  }
`;

const SearchBarForAssetList = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  padding: 0 5px 10px;
  background-color: #fff;
  box-shadow: 0px 1px 5px rgb(0 0 0 / 15%);
  margin-bottom: 10px;
`;

export { NonMonitoredAssetListBlock, SearchBarForAssetList };
